/* eslint-disable vue/html-closing-bracket-newline */
<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3 loading-area">
      <search-form :fields="search" />
      <el-button v-if="hasPermsExport" @click="jumpExport">按条件导出数据</el-button>
    </el-button-group>

    <el-table :data="userLevelApplies" resource="user-level-applies" v-loading="loading">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column align="center" header-align="center" label="申请人" width="140">
        <template slot-scope="scope">
          <div v-if="scope.row.applier_user">
            <span>{{ scope.row.applier_user.real_name }}({{ scope.row.applier_user.level_info.level_name }})</span>
            <br />
            <span>{{ scope.row.applier_user.mobile }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="left" header-align="center" label="报单人" width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            <span>{{ scope.row.user.real_name }}({{ scope.row.user.level_info.level_name }})</span>
            <br />
            <span>{{ scope.row.user.mobile }}</span>
            <br />
            <span style="color: #c0c4cc; font-size: 10px;">原点升级失效时间:</span>
            <br />
            {{ scope.row.paid_expire_time }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cur_level_name" label="当时等级" />
      <el-table-column label="申请等级">
        <template slot-scope="scope">
          <span v-if="scope.row.user_level">{{ scope.row.user_level.level_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="报单金额" width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.bill_amount }}</span>
          <div style="font-size: 12px;" v-if="scope.row.pmt_amount">(优惠:{{ scope.row.pmt_amount }})</div>
        </template>
      </el-table-column>
      <el-table-column prop="pay_status_text" label="支付类型" />
      <el-table-column label="支付订单号" width="190">
        <template slot-scope="scope">
          <div>{{ !scope.row.pay_order_no ? scope.row.debit_id : scope.row.pay_order_no }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="voucher" label="凭证" width="130">
        <template slot-scope="scope">
          <file-preview v-if="scope.row.voucher !== ''" v-model="scope.row.voucher" />
        </template>
      </el-table-column>
      <el-table-column prop="state_text" label="状态">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.state === 2 ? 'danger' : scope.row.state === 1 ? 'success' : 'warning'"
            size="small"
            disable-transitions
            >{{ scope.row.state_text }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="用户备注" />
      <el-table-column prop="created_at" label="申请时间" width="180" />
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button-group>
            <el-tooltip effect="dark" content="报单审核" placement="top">
              <el-button
                size="small"
                v-if="scope.row.state === 0 && scope.row.pay_status === 0 && hasPermsChangeAdviceStatus"
                divided
                @click="onChangeState(scope.$index, scope.row)"
                >审核</el-button
              >
            </el-tooltip>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer"><pagination :page="page" /></div>

    <el-dialog title="审核" :visible.sync="auditModifyDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        label-width="auto"
        ref="auditForm"
        :submit="onModifyAudit"
        :errors.sync="errors"
        :model="auditForm"
        label-position="left"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item required prop="state" label="结果">
          <el-select v-model="auditForm.state" placeholder="请选择"
            ><el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
          /></el-select>
        </el-form-item>
        <el-form-item label="备注" required prop="remark"
          ><el-input type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" v-model="auditForm.remark"
        /></el-form-item>
      </lz-form>
    </el-dialog>
  </el-card>
</template>

<script>
import { Loading } from 'element-ui'
import LzForm from '@c/LzForm'
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getUserLevelApplies, auditUserLevelApply, exportUserLevelApply } from '@/api/user-level-applies'
import FilePreview from '@c/FilePreview'
import { downFile } from '@/libs/download-helper'
import { can } from '@/libs/utils'

export default {
  name: 'Index',
  components: {
    LzForm,
    SearchForm,
    Pagination,
    FilePreview,
  },
  data() {
    return {
      search: [
        {
          field: 'keyword',
          label: '手机/姓名',
        },
        {
          field: 'pay_order_no',
          label: '支付订单号',
        },
        {
          field: 'pay_status',
          label: '支付类型',
          type: 'el-select',
          options: [
            // {
            //   id: 0,
            //   name: '线下支付'
            // },
            {
              id: 1,
              name: '微信支付',
            },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'state',
          label: '审核状态',
          type: 'el-select',
          options: [
            {
              id: 0,
              name: '待处理',
            },
            {
              id: 1,
              name: '审核成功',
            },
            {
              id: 2,
              name: '审核失败',
            },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'created_at',
          label: '创建时间',
          type: 'el-date-picker',
        },
      ],
      userLevelApplies: [],
      page: null,
      query: {},

      auditModifyDialog: false,
      errors: {},
      auditForm: {
        id: 0,
        state: '',
        remark: '',
      },
      options: [
        {
          value: 1,
          label: '审核通过',
        },
        {
          value: 2,
          label: '审核失败',
        },
      ],
      loading: true,
      hasPermsChangeAdviceStatus: false,
      hasPermsExport: false,
    }
  },
  created() {
    this.hasPermsChangeAdviceStatus = can('user-level-applies.audit')
    this.hasPermsExport = can('user-level-applies.export')
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.query = newVal.query
        this.loadData()
      },
      immediate: true,
    },
  },
  methods: {
    async loadData() {
      this.loading = true
      const {
        data: { data, meta },
      } = await getUserLevelApplies(this.query)
      this.userLevelApplies = data
      this.page = meta
      this.loading = false
    },
    async onChangeState(index, row) {
      console.log(row)
      this.auditForm = {
        id: row.id,
        state: '',
        remark: '',
      }
      this.auditModifyDialog = true
    },
    async onModifyAudit() {
      const { data } = await auditUserLevelApply(this.auditForm.id, this.auditForm)
      this.auditModifyDialog = false
      this.loadData()
    },
    async jumpExport() {
      const loadingInstance = Loading.service({ target: document.querySelector('.loading-area'), text: '下载中...' })
      console.log(this.query)
      const { data } = await exportUserLevelApply(this.query).setConfig({ responseType: 'blob' })
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      var fileName = 'user-level-apply.xlsx'
      downFile(blob, fileName)
      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        loadingInstance.close()
      })
    },
  },
}
</script>
